"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var theme_1 = require("../styles/theme");
/* eslint-disable */


exports["default"] = function (_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.width,
      width = _c === void 0 ? '109px' : _c,
      _d = _a.height,
      height = _d === void 0 ? '110px' : _d,
      _e = _a.fillColor,
      fillColor = _e === void 0 ? theme_1.theme.colors.Green04 : _e,
      _f = _a.strokeColor,
      strokeColor = _f === void 0 ? theme_1.theme.colors.Teal80 : _f,
      _g = _a.checkSize,
      checkSize = _g === void 0 ? 2 : _g;
  return react_1["default"].createElement("svg", {
    className: className,
    width: width,
    height: height,
    viewBox: '0 0 109 110',
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
  }, react_1["default"].createElement("g", {
    id: 'Ready-to-share-dd/mm/yy',
    stroke: 'none',
    strokeWidth: '1',
    fill: 'none',
    fillRule: 'evenodd'
  }, react_1["default"].createElement("g", {
    id: 'app-product-page',
    transform: 'translate(-882.000000, -1353.000000)'
  }, react_1["default"].createElement("g", {
    id: 'Group-5',
    transform: 'translate(353.000000, 133.000000)'
  }, react_1["default"].createElement("g", {
    id: 'Group-8',
    transform: 'translate(0.000000, 979.000000)'
  }, react_1["default"].createElement("g", {
    id: 'np_verified-badge_1008037_000000-copy',
    transform: 'translate(529.000000, 242.000000)'
  }, react_1["default"].createElement("path", {
    d: 'M99.8490566,59.0841121 C99.8490566,86.6524301 77.4976184,109 49.9245283,109 C22.3514383,109 0,86.6524301 0,59.0841121 C0,31.5157942 22.3514383,9.1682243 49.9245283,9.1682243 C77.4976184,9.1682243 99.8490566,31.5157942 99.8490566,59.0841121',
    id: 'Path-Copy-3',
    fill: theme_1.theme.colors.White
  }), react_1["default"].createElement("path", {
    d: 'M108,49.9158879 C108,77.4842058 85.6485617,99.8317757 58.0754717,99.8317757 C30.5023816,99.8317757 8.1509434,77.4842058 8.1509434,49.9158879 C8.1509434,22.3475699 30.5023816,0 58.0754717,0 C85.6485617,0 108,22.3475699 108,49.9158879',
    id: 'Path',
    stroke: strokeColor,
    strokeWidth: '2',
    fill: fillColor
  }), react_1["default"].createElement("polyline", {
    id: 'Path',
    stroke: strokeColor,
    strokeWidth: checkSize,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    points: '37.6981132 50.9327606 50.2664151 64.1775701 78.4528302 35.6542056'
  })))))));
};
/* eslint-enable */